import React from 'react'
import PropTypes from 'prop-types'

import { Icon } from '@maui/elements'

export const DrawerTitleIcon = ({ name, ...props }) => {
  return <Icon name={name} size='lg' />
}

DrawerTitleIcon.displayName = 'DrawerTitleIcon'

DrawerTitleIcon.propTypes = {
  children: PropTypes.node,
  name: PropTypes.string,
}
